import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  FaWhatsapp, FaCheckCircle, FaTractor, FaBolt, FaChartLine,
  FaTools, FaCloud, FaCoins, FaSeedling, FaCheck, FaMap, FaBars, FaTimes,
  FaArrowRight, FaArrowLeft, FaChevronDown,
  FaDatabase, FaMicrochip, FaFlask, FaTachometerAlt, FaGasPump,
  FaGithub,
} from 'react-icons/fa';
import '../styles/landingPage.scss';
import bootcamp   from '../assets/bootcamp.png';
import dynasystem from '../assets/portfolio_tractorlab_bg.png';
import dynaop     from '../assets/portfolio_bg.png';
import dynamap    from '../assets/ksatwebgis.png';
import heroDiagnostico from '../assets/hero_bg.png';
import playstoreIcon from '../assets/playstore.jpeg';
import apkIcon     from '../assets/apk.png';

import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

const GOOGLE_FORM_ACTION_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSciBwLutHhanbjJ2E_MaTn_r9f4TD8-gSktWXsZuTiyMlF84A/formResponse';

const FORM_FIELD_NAMES = {
  name:  'entry.986590372',
  email: 'entry.1278167896',
  phone: 'entry.12986911',
};

const WHATSAPP_NUMBER = '5519995910565';

const LANGUAGES = [
  { code: 'pt', flag: '🇧🇷', label: 'Português', href: '/' },
  { code: 'en', flag: '🇺🇸', label: 'English',    href: '/en' },
  { code: 'es', flag: '🇪🇸', label: 'Español',    href: '/es' },
];

const NAV_ITEMS = [
  { id: 'hero',      label: 'Inicio' },
  { id: 'problem',   label: 'Problema' },
  { id: 'portfolio', label: 'Soluciones' },
  { id: 'services',  label: 'Diagnóstico' },
  { id: 'about',     label: 'Startup' },
  { id: 'blog',      label: 'Blog', href: '/es/blog' },
];

const SLIDES = [
  {
    id: 1,
    tag: 'Sostenibilidad Agrícola',
    tagDot: '#A8FF3E',
    title: ['Toda operación agrícola genera datos.', 'Transformamos', 'esos datos en ganancias.'],
    accentLine: 1,
    accentColor: '#A8FF3E',
    subtitle: 'Conozca nuestra línea de soluciones para agricultura digital y descubra cómo identificamos puntos de ahorro en los costos de producción agrícola.',
    cta: { label: 'Conocer Soluciones', wa: 'Quiero saber cómo las soluciones de la startup pueden optimizar los costos de mi finca.' },
    badge: 'Eficiencia Agrícola',
    image: heroDiagnostico,
  },
];

const PRODUCTS = [
  {
    id: 'dynaop',
    status: 'En proceso de I+D', statusType: 'coming',
    tag: 'Deep Tech · IoT Embebido',
    name: 'Optimización de Diésel en Tiempo Real (Tractores Agrícolas)',
    description: 'Sistema embebido que combina curvas dinamométricas de motores diésel con algoritmos de optimización en tiempo real. El operador recibe indicaciones continuas para mantener el tractor en el punto de máxima eficiencia térmica, reduciendo el consumo sin perder productividad.',
    specs: [
      { icon: <FaMicrochip />, label: 'Hardware + Software' },
      { icon: <FaBolt />,      label: 'Ahorro estimado de hasta 30% por tractor' },
      { icon: <FaDatabase />,  label: 'Datos en tiempo real' },
    ],
    image: dynaop,
    action: null,
    accent: '#4A8A28',
  },
  {
    id: 'dynasystem',
    status: 'Disponible', statusType: 'live',
    tag: 'Ingeniería · Calculadora Técnica',
    name: 'Eficiencia de Tracción en el Conjunto Tractor-Implemento',
    description: 'Calculadora de tracción y lastre basada en modelos agronómicos de ingeniería agrícola. Dimensiona la fuerza de tracción necesaria, calcula la distribución de lastres e identifica el punto óptimo de patinaje para cualquier conjunto tractor-implemento.',
    specs: [
      { icon: <FaTools />,   label: 'Módulos de Tracción + Lastre' },
      { icon: <FaTractor />, label: 'Gráficos de Desempeño y Ahorro Estimado' },
      { icon: <FaFlask />,   label: 'Base científica ASABE' },
    ],
    image: dynasystem,
    storeBadges: [
      { type: 'playstore', status: 'coming',    label: 'Google Play', sub: 'Próximamente', icon: playstoreIcon },
      { type: 'apk',       status: 'available', label: 'APK Android', sub: 'Disponible',   icon: apkIcon, href: 'https://github.com/seu-usuario/dynasystem' },
    ],
    repoLink: 'https://github.com/seu-usuario/dynasystem',
    accent: '#8A6A00',
    extraAction: {
      label: 'Consultoría Técnica',
      wa: 'Quiero cotizar y saber más sobre la consultoría de optimización del conjunto suelo-tractor-implemento.',
      icon: <FaWhatsapp />,
    },
    accent: '#181818',
  },
  {
    id: 'dynamap',
    status: 'Disponible', statusType: 'live',
    tag: 'Física del Suelo · Dinámica del Agua · Plataforma WebGIS',
    name: 'Mapas de Infiltración y Zonas de Compactación',
    description: 'Diagnóstico hidrofísico de alta resolución. Mapeamos la conductividad hidráulica saturada (Ksat) para identificar zonas de manejo basadas en la capacidad real de infiltración, drenaje y retención de agua en el perfil del suelo.',
    specs: [
      { icon: <FaMap />,       label: 'Predicción mediante Machine Learning' },
      { icon: <FaFlask />,     label: 'Atributo: física del suelo' },
      { icon: <FaChartLine />, label: 'Generación de Zonas de Manejo' },
      { icon: <FaTools />, label: 'Plataforma WebGIS' },
    ],
    image: dynamap,
    action: { href: 'https://soilwater.vercel.app', label: 'Acceder a la plataforma', icon: <FaArrowRight /> },
    extraAction: {
      label: 'Cotizar Implementación WebGIS',
      wa: 'Quiero cotizar la implementación del WebGIS para mapeo de infiltración y compactación.',
      icon: <FaWhatsapp />,
    },
    accent: '#181818',
  },
];

const PROBLEMS = [
  {
    num: '01', icon: <FaBolt />, accent: '#4A8A28',
    title: 'Consumo Energético Excesivo',
    text: 'Los tractores fuera del punto óptimo de torque consumen hasta un 30% más de combustible. Ajustar la marcha y las revoluciones elimina ese desperdicio.',
  },
  {
    num: '02', icon: <FaTools />, accent: '#8A6A00',
    title: 'Desajuste Tractor-Implemento',
    text: 'Un patinaje superior al 15% o inferior al 8% indica un conjunto mal dimensionado, lo que provoca compactación y baja productividad.',
  },
  {
    num: '03', icon: <FaMap />, accent: '#006080',
    title: 'Mapeo de Conductividad Hidráulica',
    text: 'Ignorar la variabilidad del suelo compromete el manejo hídrico. Mapeamos la conductividad saturada para definir zonas de manejo precisas.',
  },
  {
    num: '04', icon: <FaChartLine />, accent: '#B23A00',
    title: 'Decisiones Sin Base en Datos',
    text: 'Sin monitoreo continuo, los ajustes dependen de la experiencia. Los datos en tiempo real convierten la intuición en precisión.',
  },
];

const SERVICES = [
  {
    ods: 'ODS 9',
    title: 'Eficiencia en el Manejo Agrícola',
    text: 'La telemetría CAN bus en tiempo real y el dimensionamiento tractor-implemento reducen el tiempo ocioso y elevan la productividad de la operación.',
    icon: <FaTractor />,
    cta: 'Leer más',
    wa: 'Quiero optimizar la eficiencia del manejo agrícola de mi flota',
    variant: 'primary',
    accent: '#6BBF3C',
  },
  {
    ods: 'ODS 13',
    title: 'Reducción de Emisiones de CO₂',
    text: 'El monitoreo del consumo de combustible (modelo Cappelli) identifica pérdidas y reduce las emisiones por hectárea operada.',
    icon: <FaCloud />,
    cta: 'Leer más',
    wa: 'Quiero reducir las emisiones de CO2 de mi operación',
    variant: 'default',
    accent: '#4A90D9',
  },
  {
    ods: 'ODS 8',
    title: 'Reducción de Costos Operativos',
    text: 'El dimensionamiento correcto (Brixius/Godwin-Reece) evita el patinaje, el desgaste prematuro y el consumo excesivo de diésel.',
    icon: <FaCoins />,
    cta: 'Leer más',
    wa: 'Quiero reducir los costos operativos de mi flota',
    variant: 'default',
    accent: '#D9A441',
  },
  {
    ods: 'ODS 2',
    title: 'Seguridad Alimentaria',
    text: 'Las decisiones basadas en datos aumentan la previsibilidad de la cosecha, sosteniendo la producción de alimentos a escala.',
    icon: <FaSeedling />,
    cta: 'Leer más',
    wa: 'Quiero fortalecer la seguridad alimentaria de mi producción',
    variant: 'primary',
    accent: '#3CA65E',
  },
];

const FORM_FIELDS = [
  { id: 'name',  label: 'Nombre Completo',  type: 'text',  placeholder: 'Juan Pérez',         autoComplete: 'name' },
  { id: 'email', label: 'Correo electrónico', type: 'email', placeholder: 'juan@finca.com',    autoComplete: 'email' },
  { id: 'phone', label: 'WhatsApp',          type: 'tel',   placeholder: '(+52) 55 1234 5678', autoComplete: 'tel' },
];

const SLIDE_INTERVAL_MS = 6000;

const LandingPageEs = () => {
  const [activeSection, setActiveSection]   = useState('hero');
  const [isMenuOpen, setIsMenuOpen]         = useState(false);
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  const [currentSlide, setCurrentSlide]     = useState(0);
  const [slideDirection, setSlideDirection] = useState('next');
  const [isSlideAnimating, setIsSlideAnimating] = useState(false);
  const [formData, setFormData]             = useState({ name: '', email: '', phone: '' });
  const [formStatus, setFormStatus]         = useState({ loading: false, success: false, error: false });
  const slideTimerRef = useRef(null);

  const sectionRefs = {
    hero:        useRef(null),
    problem:     useRef(null),
    portfolio:   useRef(null),
    services:    useRef(null),
    about:       useRef(null),
    leadCapture: useRef(null),
  };

  const hasMultipleSlides = SLIDES.length > 1;

  useEffect(() => {
    const onScroll = () => setIsHeaderScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  const goToSlide = useCallback((index, direction = 'next') => {
    if (isSlideAnimating || index === currentSlide) return;
    setSlideDirection(direction);
    setIsSlideAnimating(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsSlideAnimating(false);
    }, 600);
  }, [isSlideAnimating, currentSlide]);

  const nextSlide = useCallback(
    () => goToSlide((currentSlide + 1) % SLIDES.length, 'next'),
    [currentSlide, goToSlide]
  );
  const prevSlide = useCallback(
    () => goToSlide((currentSlide - 1 + SLIDES.length) % SLIDES.length, 'prev'),
    [currentSlide, goToSlide]
  );

  const resetTimer = useCallback(() => {
    clearInterval(slideTimerRef.current);
    if (hasMultipleSlides) {
      slideTimerRef.current = setInterval(nextSlide, SLIDE_INTERVAL_MS);
    }
  }, [nextSlide, hasMultipleSlides]);

  useEffect(() => {
    if (!hasMultipleSlides) return undefined;
    slideTimerRef.current = setInterval(nextSlide, SLIDE_INTERVAL_MS);
    return () => clearInterval(slideTimerRef.current);
  }, [nextSlide, hasMultipleSlides]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 100;
      for (const [section, ref] of Object.entries(sectionRefs)) {
        if (ref.current && ref.current.offsetTop <= scrollPos) {
          setActiveSection(section);
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    sectionRefs[id]?.current?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const openWhatsApp = (message) =>
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');

  const handleFormChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, success: false, error: false });

    const body = new URLSearchParams();
    body.append(FORM_FIELD_NAMES.name,  formData.name);
    body.append(FORM_FIELD_NAMES.email, formData.email);
    body.append(FORM_FIELD_NAMES.phone, formData.phone);

    try {
      await fetch(GOOGLE_FORM_ACTION_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setFormStatus({ loading: false, success: true, error: false });
      setFormData({ name: '', email: '', phone: '' });
    } catch {
      setFormStatus({ loading: false, success: false, error: true });
    }
  };

  const slide = SLIDES[currentSlide];

  const handleLeadSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const msg = [
      `*Diagnóstico DynaTech*`,
      `Nombre: ${data.get('nombre')}`,
      `Correo: ${data.get('correo')}`,
      `WhatsApp: ${data.get('whatsapp')}`,
      `Finca: ${data.get('finca')}`,
      `Área total: ${data.get('area')} ha`,
      `Interés principal: ${data.get('interes')}`,
    ].join('\n');
    openWhatsApp(msg);
  };

  return (
    <div className="lp">

      <header className={`lp__header ${isHeaderScrolled || isMenuOpen ? 'lp__header--scrolled' : ''}`}>
        <div className="lp__header-inner">
          <a className="lp__logo" href="/es">
            <FaTractor aria-hidden="true" /><span>DYNA<em>TECH</em></span>
          </a>

          <nav className={`lp__nav ${isMenuOpen ? 'lp__nav--open' : ''}`} aria-label="Navegación principal">
            {NAV_ITEMS.map(({ id, label, href }) => (
              href ? (
                <a key={id} href={href} className="lp__nav-link">{label}</a>
              ) : (
                <button
                  key={id}
                  type="button"
                  className={`lp__nav-link ${activeSection === id ? 'lp__nav-link--active' : ''}`}
                  onClick={() => scrollToSection(id)}
                >
                  {label}
                </button>
              )
            ))}

            <div className="lp__lang-switcher">
              {LANGUAGES.map(({ code, flag, label, href }) => (
                <button
                  key={code}
                  type="button"
                  title={label}
                  aria-label={label}
                  onClick={() => { window.location.href = href; }}
                >
                  {flag}
                </button>
              ))}
            </div>

            <button
              type="button"
              className="lp__nav-cta"
              onClick={() => openWhatsApp('Me gustaría saber cómo DynaTech puede optimizar mi operación.')}
            >
              <FaWhatsapp aria-hidden="true" /> Contáctenos
            </button>
          </nav>

          <button
            type="button"
            className="lp__menu-btn"
            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      <section className="lp__hero" ref={sectionRefs.hero}>
        <div
          className={`lp__hero-bg ${isSlideAnimating ? `lp__hero-bg--${slideDirection}` : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          role="img"
          aria-label={slide.badge}
        />
        <div className="lp__hero-overlay" />

        <div className={`lp__hero-content ${isSlideAnimating ? 'lp__hero-content--exit' : 'lp__hero-content--enter'}`}>
          <h1 className="lp__hero-title">
            {slide.title.map((line, i) => (
              <span key={line} style={{ animationDelay: `${i * 0.08}s` }}>
                {i === slide.accentLine ? <em style={{ color: slide.accentColor }}>{line}</em> : line}
              </span>
            ))}
          </h1>

          <p className="lp__hero-sub">{slide.subtitle}</p>

          <div className="lp__hero-actions">
            <button
              type="button"
              className="lp__btn lp__btn--primary"
              style={{ background: slide.accentColor, color: '#0A1A0B' }}
              onClick={() => openWhatsApp(slide.cta.wa)}
            >
              <FaWhatsapp aria-hidden="true" /> {slide.cta.label}
            </button>
            <button type="button" className="lp__btn lp__btn--outline-light" onClick={() => scrollToSection('portfolio')}>
              Ver Soluciones <FaArrowRight aria-hidden="true" />
            </button>
          </div>

          <div className="lp__hero-badge">
            <span style={{ color: slide.accentColor }}>✦</span> {slide.badge}
          </div>
        </div>

        {hasMultipleSlides && (
          <>
            <div className="lp__carousel-controls">
              <button
                type="button"
                className="lp__carousel-arrow"
                aria-label="Diapositiva anterior"
                onClick={() => { prevSlide(); resetTimer(); }}
              >
                <FaArrowLeft />
              </button>
              <div className="lp__carousel-dots">
                {SLIDES.map((s, i) => (
                  <button
                    key={s.id}
                    type="button"
                    aria-label={`Ir a la diapositiva ${i + 1}`}
                    className={`lp__carousel-dot ${i === currentSlide ? 'lp__carousel-dot--active' : ''}`}
                    style={i === currentSlide ? { background: slide.accentColor } : undefined}
                    onClick={() => { goToSlide(i, i > currentSlide ? 'next' : 'prev'); resetTimer(); }}
                  />
                ))}
              </div>
              <button
                type="button"
                className="lp__carousel-arrow"
                aria-label="Siguiente diapositiva"
                onClick={() => { nextSlide(); resetTimer(); }}
              >
                <FaArrowRight />
              </button>
            </div>

            <div className="lp__carousel-counter">
              <span style={{ color: slide.accentColor }}>{String(currentSlide + 1).padStart(2, '0')}</span>
              <span className="lp__carousel-counter-sep" />
              <span>{String(SLIDES.length).padStart(2, '0')}</span>
            </div>
          </>
        )}

        <button type="button" className="lp__scroll-hint" aria-label="Desplazarse a la siguiente sección" onClick={() => scrollToSection('problem')}>
          <FaChevronDown />
        </button>
      </section>

      <section className="lp__problem" ref={sectionRefs.problem}>
        <div className="lp__container">
          <div className="lp__problem-intro">
            <div>
              <h2 className="lp__section-title">
                Ineficiencia invisible<br />
                <span>que erosiona la ganancia</span>
              </h2>
            </div>
            <p className="lp__section-sub">
              Cada operación agrícola carga pérdidas silenciosas. Identificarlas es el primer paso para transformar el costo en rentabilidad.
            </p>
          </div>

          <div className="lp__problem-grid">
            {PROBLEMS.map((card) => (
              <div key={card.num} className="lp__problem-card" style={{ '--card-accent-color': card.accent }}>
                <span className="lp__problem-icon" style={{ color: card.accent }}>{card.icon}</span>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="lp__portfolio" ref={sectionRefs.portfolio}>
        <div className="lp__container">
          {/* <h2 className='h2-portfolio'>Nuestro Portafolio de Agricultura de Precisión</h2> */}
          <div className="lp__portfolio-layout">
            <div className="lp__portfolio-intro">
              <div className="lp__eyebrow">La Plataforma DynaTech</div>
              <h2 className="lp__section-title">
                Soluciones digitales para una toma de decisiones con <span>reducción de costos</span>
              </h2>
              <p className="lp__section-sub">
                Una plataforma completa que recopila, analiza y transforma datos en inteligencia para que usted tome mejores decisiones.
              </p>
              <button type="button" className="lp__btn lp__btn--primary" onClick={() => scrollToSection('portfolio')}>
                Ver plataforma <FaArrowRight aria-hidden="true" />
              </button>
            </div>

            <div className="lp__portfolio-grid">
              {PRODUCTS.map((product) => (
                <article key={product.id} className="lp__product-card">
                  <div className="lp__product-card-image">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>

                  <div className="lp__product-card-body">
                    <h3>{product.name}</h3>
                    <p>{product.description}</p>

                    <ul className="lp__product-card-checklist">
                      {product.specs.map((spec) => (
                        <li key={spec.label}>
                          <FaCheck style={{ color: product.accent }} aria-hidden="true" />
                          {spec.label}
                        </li>
                      ))}
                    </ul>

                    {product.storeBadges && (
                      <div className="lp__product-stores">
                        {product.storeBadges.map((badge) => (
                          <div key={badge.type} className={`lp__store-badge lp__store-badge--${badge.status}`}>
                            <img src={badge.icon} alt="" loading="lazy" decoding="async" />
                            <div className="lp__store-badge-text">
                              <span className="lp__store-badge-label">{badge.sub}</span>
                              <strong>{badge.label}</strong>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {product.action && (
                      <a
                        href={product.action.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="lp__btn lp__btn--product"
                        style={{ background: product.accent, color: '#fff' }}
                      >
                        {product.action.label} {product.action.icon}
                      </a>
                    )}

                    {product.extraAction && (
                      <button
                        type="button"
                        className="lp__btn lp__btn--product"
                        style={{ background: '#F5A623', color: '#1A1A1A' }}
                        onClick={() => openWhatsApp(product.extraAction.wa)}
                      >
                        {product.extraAction.icon} {product.extraAction.label}
                      </button>
                    )}

                    {!product.action && !product.storeBadges && !product.repoLink && !product.extraAction && (
                      <button type="button" className="lp__btn lp__btn--soon" disabled>
                        <span className="lp__btn-soon-dot" /> Próximamente
                      </button>
                    )}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="lp__results">
        <div className="lp__container">
          <div className="lp__results-inner">
            <div className="lp__results-text">
              <div className="lp__eyebrow">Resultados</div>
              <h2 className="lp__section-title">
                Impacto medible <br /><span>en cada operación.</span>
              </h2>
              <p className="lp__section-sub">
                Datos que transforman la gestión de su finca en decisiones precisas y rentables.
              </p>
            </div>

            <div className="lp__results-cards">
              <div className="lp__result-card">
                <span className="lp__result-icon"><FaTachometerAlt /></span>
                <h3>Monitoreo de Consumo Específico</h3>
              </div>
              <div className="lp__result-card">
                <span className="lp__result-icon"><FaGasPump /></span>
                <h3>Litros/hora Ahorrados</h3>
              </div>
              <div className="lp__result-card">
                <span className="lp__result-icon"><FaSeedling /></span>
                <h3>Mejora en el Manejo del Suelo</h3>
              </div>
              <div className="lp__result-card">
                <span className="lp__result-icon"><FaChartLine /></span>
                <h3>Decisiones Basadas en Datos</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="lp__services" ref={sectionRefs.services}>
        <div className="lp__container">
          <div className="lp__services-header">
            <div className="lp__eyebrow lp__eyebrow--light">Diagnóstico de Alto Impacto</div>
            <h2 className="lp__section-title lp__section-title--light">
              4 Pilares de Optimización<br />
              <em>para Cada Operación</em>
            </h2>
            <p className="lp__section-sub lp__section-sub--light">
              Metodología estructurada de ingeniería agrícola para transformar datos de campo en decisiones concretas de mejora operativa.
            </p>
          </div>

          <div className="lp__services-grid">
            {SERVICES.map((svc) => (
              <div key={svc.title} className={`lp__service-card lp__service-card--${svc.variant}`}>
                <span className="lp__service-ods">{svc.ods}</span>
                <span className="lp__service-icon" style={{ color: svc.accent }}>{svc.icon}</span>
                <h3 className="lp__service-title">{svc.title}</h3>
                <p className="lp__service-text">{svc.text}</p>
                <button type="button" className="lp__service-cta" onClick={() => openWhatsApp(svc.wa)}>
                  {svc.cta} <FaArrowRight aria-hidden="true" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="lp__about" ref={sectionRefs.about}>
        <div className="lp__container">
          <div className="lp__about-grid">
            <div className="lp__about-image">
              <div className="lp__about-main-img">
                <img
                  src={bootcamp}
                  alt="Equipo DynaTech durante el bootcamp Sebrae for Startups"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            <div className="lp__about-content">
              <div className="lp__eyebrow">La Startup</div>
              <h2 className="lp__section-title">
                DynaTech - Ecosistema AgTech<br />
                <span>con Rigor Científico</span>
              </h2>
              <p>
                DynaTech nació de la intersección entre la investigación académica en mecanización agrícola,
                machine learning, física del suelo y el desarrollo de tecnología de frontera. A través de la ingeniería de software, combinamos el conocimiento profundo del dominio del problema agrícola con sistemas embebidos y aplicaciones (móvil y web), cubriendo todo el ciclo de desarrollo de producto para la agricultura digital.
              </p>

              <div className="lp__about-badges">
                <div className="lp__about-badge">
                  <div>
                    <strong>André Luiz Bandeli Júnior (Founder)</strong>
                    <span>Estudiante de Ingeniería Agrícola, Unicamp | Técnico en Mecatrónica, COTUCA/UNICAMP | Ingeniería de Software | Linkedin: <a href="linkedin.com/in/andrebandeli/">/andrebandeli</a> | Investigación: <a href="https://www.researchgate.net/profile/Andre-Bandeli-Junior">Researchgate</a></span>
                    <br /><span>Campinas, São Paulo, Brasil.</span>
                  </div>
                </div>
                <div className="lp__about-badge">
                  <div>
                    <strong>Sebrae for Startups | IPT | ABStartups</strong>
                    <span>Validación del Modelo de Negocio | Finalistas — Spark 2025 | Clasificación Deeptech | Innovación de Frontera</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="lp__cta-strip" id="diagnostico">
        <div className="lp__container">
          <h2>No deje que la pérdida se convierta<br /><span>en su próximo costo fijo.</span></h2>
          <p>Descubra cuánto puede ahorrar con nuestra solución de optimización agrícola.</p>

          <div className="wg-lead__form lp__cta-strip-form">
            <form onSubmit={handleLeadSubmit}>

              <div className="wg-lead__form-row">
                <input name="nombre" type="text"  placeholder="Nombre completo"     required />
                <input name="correo" type="email" placeholder="Correo electrónico"  required />
              </div>

              <div className="wg-lead__form-row">
                <input name="whatsapp" type="tel"  placeholder="WhatsApp (con código de país)" required />
                <input name="finca"    type="text" placeholder="Finca / municipio"              required />
              </div>

              <div className="wg-lead__form-row">
                <input name="area" type="number" placeholder="Área total (ha)" required min="1" />
                <select name="interes" required>
                  <option value="">Estoy interesado en...</option>
                  <option value="Optimización de diésel (Dyna Operador)">Optimización de diésel</option>
                  <option value="Eficiencia de tracción tractor-implemento">Tracción tractor-implemento</option>
                  <option value="Mapeo de suelo (WebGIS)">Mapeo de suelo (WebGIS)</option>
                  <option value="Aún no lo sé, quiero una evaluación">Aún no lo sé, quiero evaluación</option>
                </select>
              </div>

              <button type="submit" className="wg-btn wg-btn--primary wg-btn--block">
                <FaWhatsapp /> Enviar y hablar con un especialista
              </button>

            </form>
          </div>
        </div>
      </section>

      <footer className="lp__footer">
        <div className="lp__container">
          <div className="lp__footer-grid">
            <div className="lp__footer-brand">
              <a className="lp__logo" href="/es"><FaTractor aria-hidden="true" /><span>DYNA<em>TECH</em></span></a>
              <p>Optimización agrícola con base científica. Del campo a la toma de decisiones.</p>
            </div>

            <div className="lp__footer-col">
              <h4>Soluciones</h4>
              <a href="/es/blog/dynaoperator">Dyna Operador</a>
              <a href="https://dynasystem.onrender.com/" target="_blank" rel="noopener noreferrer">Dyna System</a>
              <a href="/es/blog/dynamap">Dyna Map</a>
            </div>

            <div className="lp__footer-col">
              <h4>Empresa</h4>
              <a href="/es/about">Quiénes Somos</a>
              <a href="/es/blog">Blog DynaTech</a>
            </div>

            <div className="lp__footer-col">
              <h4>Contacto</h4>
              <button
                type="button"
                className="lp__footer-col-link-btn"
                onClick={() => openWhatsApp('Hola, me gustaría más información sobre DynaTech.')}
              >
                <FaWhatsapp aria-hidden="true" /> WhatsApp
              </button>
              <a href="">Linkedin</a>
              <a href="mailto:agritech.dyna@gmail.com">agritech.dyna@gmail.com</a>

            </div>
          </div>

          <div className="lp__footer-bottom">
            <p>© 2026 DynaTech · AgTech de Optimización Agrícola · Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageEs;